import { render, staticRenderFns } from "./CateringIndex.vue?vue&type=template&id=0dd52162&scoped=true&"
import script from "./CateringIndex.vue?vue&type=script&lang=js&"
export * from "./CateringIndex.vue?vue&type=script&lang=js&"
import style0 from "./CateringIndex.vue?vue&type=style&index=0&id=0dd52162&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd52162",
  null
  
)

export default component.exports